'use strict';

"use strict";
const pluginVersion = "12.4.2";
const defaultOptions = {
  selectedSeries: 0
};

exports.defaultOptions = defaultOptions;
exports.pluginVersion = pluginVersion;
